/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CreateRoleTemplateModal_organization$ref = any;
type RoleTemplatesList_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type RoleTemplatesSectionView_organization$ref: FragmentReference;
declare export opaque type RoleTemplatesSectionView_organization$fragmentType: RoleTemplatesSectionView_organization$ref;
export type RoleTemplatesSectionView_organization = {|
  +$fragmentRefs: RoleTemplatesList_organization$ref & CreateRoleTemplateModal_organization$ref,
  +$refType: RoleTemplatesSectionView_organization$ref,
|};
export type RoleTemplatesSectionView_organization$data = RoleTemplatesSectionView_organization;
export type RoleTemplatesSectionView_organization$key = {
  +$data?: RoleTemplatesSectionView_organization$data,
  +$fragmentRefs: RoleTemplatesSectionView_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleTemplatesSectionView_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoleTemplatesList_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateRoleTemplateModal_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4f20c13773f5f30a1f3871f3bda89d49';

module.exports = node;
